"use strict";
exports.__esModule = true;
exports.messages = void 0;
// (C) 2019-2022 GoodData Corporation
var react_intl_1 = require("react-intl");
//NOTE: Follow up ticket for move all messages: https://gooddata.atlassian.net/browse/FET-1050
exports.messages = react_intl_1.defineMessages({
    top: { id: "visualizations.legend.text.top" },
    bottom: { id: "visualizations.legend.text.bottom" },
    left: { id: "visualizations.legend.text.left" },
    right: { id: "visualizations.legend.text.right" },
    colon: { id: "visualizations.legend.text.colon" },
    column: { id: "visualizations.legend.text.column" },
    line: { id: "visualizations.legend.text.line" },
    area: { id: "visualizations.legend.text.area" },
    combo: { id: "visualizations.legend.text.combo" }
});
//# sourceMappingURL=locales.js.map